// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Form, FormGroup, Col, FormControl, Button, ControlLabel, ButtonToolbar, ToggleButtonGroup, ToggleButton, Clearfix, Alert, Row, Checkbox } from 'react-bootstrap'
import { Link } from 'react-router'
import config from '../config/config.json'
import { validateEmail, printableJsonError } from '../utils/enUtils.js'

export class Register extends Component {
    constructor(props) {
        super(props)

        this.providerApi = config[this.props.env] + config.api.provider_signup.endpoint
        this.workerApi = config[this.props.env] + config.api.worker_signup.endpoint

        this.state = {
            formAlertType: 'danger',
            formAlertDisplay: 'none',
            formAlertText: '',
            companyDisplay: 'block',
            userTypeDisplay: 'block',
            firstNameError: null,
            lastNameError: null,
            companyError: null,
            passwordError: null,
            confirmPasswordError: null,
            showPassword: false,
            agreement: false,
            profileType: this.props.appData.profileType,
            providerTheme: null
        }

        this.registerSuccess = 'Account created successfully! An email as been sent to you with further instructions.'
            + ' Please check your junk folder if you have not received it, and mark Enabler as a safe contact.'

        this.handleOnSubmit = this.handleOnSubmit.bind(this)
        this.addSupportWorker = this.addSupportWorker.bind(this)
        this.addServiceProvider = this.addServiceProvider.bind(this)
        this.formAlertUpdate = this.formAlertUpdate.bind(this)
        this.handleOnChangeFirstName = this.handleOnChangeFirstName.bind(this)
        this.handleOnChangeLastName = this.handleOnChangeLastName.bind(this)
        this.handleOnChangeCompany = this.handleOnChangeCompany.bind(this)
        this.handleOnChangeType = this.handleOnChangeType.bind(this)
        this.handleOnChangeEmail = this.handleOnChangeEmail.bind(this)
        this.handleOnChangePassword = this.handleOnChangePassword.bind(this)
        this.handleOnChangeConfirmPassword = this.handleOnChangeConfirmPassword.bind(this)
        this.handleShowPassword = this.handleShowPassword.bind(this)
        this.handleAgreement = this.handleAgreement.bind(this)
    }

    handleOnSubmit(e) {
        e.preventDefault()

        let formData = {
            profileType: this.proInput.state.values.value,
            email: this.emailInput.value,
            fname: this.fnameInput.value,
            lname: this.lnameInput.value,
            company: this.companyInput.value,
            password: this.passwordInput.value,
            confPassword: this.confPasswordInput.value,
            provider_id: this.props.location.query.provider_id || '',
            invite_token: this.props.location.query.invite_token || ''
        }

        if (this.isValidInput(formData)) {
            formData.profileType === 'Service Provider' ? this.addServiceProvider(formData) : this.addSupportWorker(formData)
        }
    }

    clearInputFields() {
        this.emailInput.value = ''
        this.fnameInput.value = ''
        this.lnameInput.value = ''
        this.companyInput.value = ''
        this.passwordInput.value = ''
        this.confPasswordInput.value = ''
    }

    isValidInput(formData) {
        if (!formData.fname) {
            this.setState({ firstNameError: 'error' })
            alert("Please enter your first name")
        } else if (!formData.lname) {
            this.setState({ lastNameError: 'error' })
            alert("Please enter your last name")
        } else if (formData.profileType === 'Service Provider' && !formData.company) {
            this.setState({ companyError: 'error' })
            alert("Please enter an organisation name")
        } else if (!formData.email) {
            this.setState({ emailError: 'error' })
            alert("Please enter an email address")
        } else if (!validateEmail(formData.email)) {
            this.setState({ emailError: 'error' })
            alert("Email address is invalid")
        } else if (!formData.password) {
            this.setState({ passwordError: 'error' })
            alert("Please enter a password")
        } else if (!formData.confPassword) {
            this.setState({ confirmPasswordError: 'error' })
            alert("Please confirm your password")
        } else if (formData.password !== formData.confPassword) {
            this.setState({ confirmPasswordError: 'error' })
            alert("Passwords do not match")
        } else {
            return true;
        }

        return false;
    }

    formAlertUpdate(type, display, text) {
        this.setState({
            formAlertType: type,
            formAlertDisplay: display,
            formAlertText: text
        })
    }

    clearFormAlert() {
        this.formAlertUpdate('success', 'none', '')
    }

    getProviderTheme(provider_id, invite_token) {
        if (provider_id) {
            fetch(config[this.props.env] + config.api.provider_theme.endpoint + "/" + provider_id + "/" + invite_token, {
                method: config.api.provider_theme.type,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }).then((response) => response.json())
                .then((responseJson) => {
                    if ('errors' in responseJson) {
                        let errorMessage = printableJsonError(responseJson.errors)
                        console.log(errorMessage)
                    } else {
                        this.setState({
                            providerTheme: responseJson
                        })
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }

    addSupportWorker(formValues) {
        fetch(this.workerApi, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                worker: {
                    email: formValues.email,
                    password: formValues.password,
                    first_name: formValues.fname,
                    last_name: formValues.lname,
                    provider_id: formValues.provider_id,
                    invite_token: formValues.invite_token,
                    my_tag: formValues.company
                }
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                //console.log(responseJson);

                if ('errors' in responseJson) {
                    let errorMessage = printableJsonError(responseJson.errors)
                    this.formAlertUpdate('danger', 'block', errorMessage)
                }
                else {
                    this.formAlertUpdate('success', 'block', this.registerSuccess)
                    this.clearInputFields()
                }
            })
            .catch((error) => {
                console.error(error);
                this.formAlertUpdate('danger', 'block', 'error')
            });
    }

    addServiceProvider(formValues) {
        fetch(this.providerApi, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                provider: {
                    email: formValues.email,
                    name: formValues.company,
                    address: '',
                    admin_first_name: formValues.fname,
                    admin_last_name: formValues.lname,
                    password: formValues.password,
                    password_confirmation: formValues.confPassword
                }
            })
        }).then((response) => response.json())
            .then((responseJson) => {
                if ('errors' in responseJson) {
                    let errorMessage = printableJsonError(responseJson.errors)
                    this.formAlertUpdate('danger', 'block', errorMessage)
                } else {
                    this.formAlertUpdate('success', 'block', this.registerSuccess)
                    this.clearInputFields()
                }
            })
            .catch((error) => {
                console.error(error, this);
                this.formAlertUpdate('danger', 'block', 'error')
            })
    }

    handleOnChangeType(value) {
        value === "Service Provider" ? this.setState({ companyDisplay: 'block', profileType: 'provider' }) : this.setState({ companyDisplay: 'none', profileType: 'worker' })
    }

    handleOnChangeFirstName(e) {
        this.clearFormAlert()
        if (e.target.value.length > 0) {
            this.setState({
                firstNameError: null
            })
        }
    }

    handleOnChangeLastName(e) {
        this.clearFormAlert()
        if (e.target.value.length > 0) {
            this.setState({
                lastNameError: null
            })
        }
    }

    handleOnChangeCompany(e) {
        this.clearFormAlert()
        if (e.target.value.length > 0) {
            this.setState({
                companyError: null
            })
        }
    }

    handleOnChangeEmail(e) {
        this.clearFormAlert()
        if (e.target.value.length > 0) {
            this.setState({
                emailError: null
            })
        }
    }

    handleOnChangePassword(e) {
        this.clearFormAlert()
        if (e.target.value.length > 0) {
            this.setState({
                passwordError: null
            })
        }
    }

    handleOnChangeConfirmPassword(e) {
        this.clearFormAlert()
        if (e.target.value.length > 0) {
            this.setState({
                confirmPasswordError: null
            })
        }
    }

    componentWillMount() {
        if ('provider_id' in this.props.location.query) {
            this.setState({
                companyDisplay: 'none',
                userTypeDisplay: 'none',
                profileType: 'worker'
            })
        }
    }

    componentDidMount() {
        this.getProviderTheme(this.props.location.query.provider_id, this.props.location.query.invite_token)
    }

    handleShowPassword(e) {
        this.setState({
            showPassword: e.target.checked
        })
    }

    handleAgreement(e) {
        this.setState({
            agreement: e.target.checked
        })
    }

    render() {
        // Provider theme (default welcome is to Enabler Interactive)
        let bannerColorOverride = this.state.providerTheme !== null ? this.state.providerTheme.color_1 : null
        const bannerStyleOverride = bannerColorOverride ? { backgroundColor: bannerColorOverride } : null
        let providerName = (this.state.providerTheme !== null && this.state.providerTheme.name !== "") ? this.state.providerTheme.name : "Enabler Interactive"
        let providerLogoUrl = this.state.providerTheme !== null ? this.state.providerTheme.logo : null

        // Organisation label
        let companyLabel = this.state.profileType === 'provider' ? "Organisation Name" : "Your Organisation"
        let companyPlaceholder = this.state.profileType === 'provider' ? "Organisation Name" : "Your Organisation"
        let companyTagAllowed = this.state.profileType === 'provider'
            || (this.state.profileType === 'worker' && this.state.providerTheme !== null && this.state.providerTheme.signup_tag === true)

        let containerClass = ""
        if (this.state.profileType === 'provider') {
            containerClass = "provider-registration-container registration-container page-container"
        }
        else {
            containerClass = "registration-container page-container"
        }

        return (
            <div className={containerClass}>
                <div className="banner" style={bannerStyleOverride}>
                    <Col smOffset={2} sm={8}>
                        <h2 className="title">Create Account</h2>
                        <p className="sub-heading">Welcome to {providerName}, just a few details to get you started</p>
                    </Col>
                    <Clearfix />
                </div>

                <Row>
                    <Col sm={12}>
                        <Alert bsStyle={this.state.formAlertType} style={{ display: this.state.formAlertDisplay }} onDismiss={this.handleAlertDismiss}>
                            <h3>{this.state.formAlertType === 'danger' ? "Creation unsuccessful" : "Success"}</h3>
                            <p className="alert-text">{this.state.formAlertText}</p>
                        </Alert>
                    </Col>
                </Row>

                <Form horizontal className="registration-form">
                    <FormGroup controlId="formHorizontalRadio" style={{ display: this.state.userTypeDisplay }}>
                        <Col componentClass={ControlLabel} sm={4}>
                            I am an
                        </Col>
                        <Col sm={5}>
                            <ButtonToolbar>
                                <ToggleButtonGroup type="radio" name="options" defaultValue={typeof this.props.location.query.provider_id === 'undefined' ? 'Service Provider' : 'Support Worker'} ref={input => { this.proInput = input }} onChange={this.handleOnChangeType}>
                                    <ToggleButton value="Service Provider" >
                                        Organisation
                                    </ToggleButton>
                                    <ToggleButton value="Support Worker" >Individual</ToggleButton>
                                </ToggleButtonGroup>
                            </ButtonToolbar>
                        </Col>
                    </FormGroup>
                    {providerLogoUrl && <FormGroup controlId="formHorizontalLogo" >
                        <Col xs={0} sm={4} md={4} lg={4}>
                        </Col>
                        <Col xs={4} sm={3} md={2} lg={1}>
                            <img src={providerLogoUrl} alt="Invite Logo" style={{ align: "left" }} />
                        </Col>
                        <Col xs={0} sm={2} md={3} lg={4}>
                        </Col>
                    </FormGroup>}
                    <FormGroup controlId="formHorizontalFName" validationState={this.state.firstNameError}>
                        <Col componentClass={ControlLabel} sm={4}>
                            First Name
                        </Col>
                        <Col sm={5}>
                            <FormControl type="text" placeholder="First Name" autoComplete="givenName" inputRef={ref => { this.fnameInput = ref }} onChange={this.handleOnChangeFirstName} />
                            <FormControl.Feedback />
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="formHorizontalLName" validationState={this.state.lastNameError}>
                        <Col componentClass={ControlLabel} sm={4}>
                            Last Name
                        </Col>
                        <Col sm={5}>
                            <FormControl type="text" placeholder="Last Name" autoComplete="familyName" inputRef={ref => { this.lnameInput = ref }} onChange={this.handleOnChangeLastName} />
                            <FormControl.Feedback />
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="formHorizontalCompany" validationState={this.state.companyError} hidden={!companyTagAllowed}>
                        <Col componentClass={ControlLabel} sm={4}>
                            {companyLabel}
                        </Col>
                        <Col sm={5}>
                            <FormControl type="text" placeholder={companyPlaceholder} inputRef={ref => { this.companyInput = ref }} onChange={this.handleOnChangeCompany} />
                            <FormControl.Feedback />
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="formHorizontalEmail" validationState={this.state.emailError}>
                        <Col componentClass={ControlLabel} sm={4}>
                            Email
                        </Col>
                        <Col sm={5}>
                            <FormControl type="email" placeholder="Email" autoComplete="email" inputRef={ref => { this.emailInput = ref }} onChange={this.handleOnChangeEmail} />
                            <FormControl.Feedback />
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="formHorizontalPassword" validationState={this.state.passwordError}>
                        <Col componentClass={ControlLabel} sm={4}>
                            Password
                        </Col>
                        <Col sm={5}>
                            <FormControl type={this.state.showPassword ? "text" : "password"} placeholder="Password" autoComplete="new-password" inputRef={ref => { this.passwordInput = ref }} onChange={this.handleOnChangePassword} />
                            <FormControl.Feedback />
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="formHorizontalConfirmPassword" validationState={this.state.confirmPasswordError}>
                        <Col componentClass={ControlLabel} sm={4}>
                            Confirm Password
                        </Col>
                        <Col sm={5}>
                            <FormControl type={this.state.showPassword ? "text" : "password"} placeholder="Confirm Password" autoComplete="new-password" inputRef={ref => { this.confPasswordInput = ref }} onChange={this.handleOnChangeConfirmPassword} />
                            <FormControl.Feedback />
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="formHorizontalShowPassword">
                        <Col smOffset={4} sm={5}>
                            <Checkbox onChange={this.handleShowPassword} >
                                Show Password
                            </Checkbox>
                        </Col>
                    </FormGroup>
                    <FormGroup controlId="formHorizontalTerms">
                        <Col smOffset={4} sm={5}>
                            <Checkbox onChange={this.handleAgreement} >
                                I have read and agree to the <a href='https://www.enablerinteractive.com/termsandconditions' target='_blank' rel='noopener noreferrer'>Terms and Conditions</a> and <a href='https://www.enablerinteractive.com/privacypolicy' target='_blank' rel='noopener noreferrer'>Privacy Policy</a>.
                            </Checkbox>
                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col smOffset={4} sm={6}>
                            <Button type="submit" bsStyle="primary" onClick={this.handleOnSubmit} disabled={!this.state.agreement}>
                                Create
                            </Button>

                        </Col>
                    </FormGroup>
                    <FormGroup>
                        <Col smOffset={4} >
                            <span className="add-opts">Have an account?<Link to='/login'> Login Here</Link></span>
                        </Col>
                    </FormGroup>
                </Form>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/containers/register.js